<template>
    <clients-section title="They Chose Us|Ils nous ont choisis">
<!--        <client-card src="img/clients-color/municipalities/bois_des_filion.png" bg>-->
<!--            Bois des Filion-->
<!--        </client-card>-->
        <client-card src="img/clients-color/municipalities/cote_st_luc.png" bg>
            Cote St Luc
        </client-card>
        <client-card src="img/clients-color/municipalities/gatineau.png" bg>
            Gatineau
        </client-card>
        <client-card src="img/clients-color/municipalities/montreal.png" bg>
            Montreal
        </client-card>
        <client-card src="img/clients-color/municipalities/ville-bromont.png" bg>
            Ville de Bromont
        </client-card>
        <client-card src="img/clients-color/municipalities/ville-drummondville.png" bg>
            Ville de Drummondville
        </client-card>
        <client-card src="img/clients-color/municipalities/ville-terrebonne.png">
            Ville de Terrebonne
        </client-card>
    </clients-section>
</template>

<script>

import ClientCard from "@/components/client-card.vue";
import ClientsSection from "@/components/clients-section.vue";
export default {
    name: `wifi-municipalities-client-card`,
    components: {ClientCard, ClientsSection},
    data() {
        return {
            altPrefix: this.tr(`City and municipalities client guest wifi|Client villes wifi social`)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
